import { YesObject } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'

type SelectObjectSourceProps = {
  objectFromIndex?: YesObject
  objectFromUuid?: YesObject
  fetchObjectFromIndex: () => Promise<unknown>
  fetchObjectFromUuid: () => Promise<unknown>
  isFetchingObjectFromUuid: boolean
  isFetchingObjectFromIndex: boolean
  objectOrigin: 'uuid' | 'index'
}

export default function useObjectFromSource({
  objectFromIndex,
  objectFromUuid,
  fetchObjectFromIndex,
  fetchObjectFromUuid,
  isFetchingObjectFromUuid,
  isFetchingObjectFromIndex,
  objectOrigin
}: SelectObjectSourceProps) {
  const refetchObject = useCallback(async () => {
    if (objectFromIndex && objectOrigin === 'index') {
      return fetchObjectFromIndex()
    }

    if (objectFromUuid && objectOrigin === 'uuid') {
      return fetchObjectFromUuid()
    }
  }, [
    fetchObjectFromIndex,
    fetchObjectFromUuid,
    objectFromIndex,
    objectFromUuid,
    objectOrigin
  ])

  return {
    yesObject: objectOrigin === 'index' ? objectFromIndex : objectFromUuid,
    refetchObject,
    isFetchingObject: isFetchingObjectFromUuid || isFetchingObjectFromIndex
  }
}
